/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { TextField } from '@client/new/components/basic';
import { Button } from '@design-system/components/button/button';
import { Input } from '@design-system/components/input/input';

import { Col } from '@design-system/components/grid/grid';
import { space } from '@design-system/tokens';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef } from 'react';
import { ctaButton } from './TextInput.css';
type Props = {
  label?: string;
  description?: string;
  value?: string;
  placeholder?: string;
  ctaContent?: string;
  error?: string;
  rightIcon?: IconProp;
  endCta?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement | SVGElement>) => void;
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export const TextInput = forwardRef<HTMLInputElement, Props>(
  ({ onClick, error, size, color, rightIcon, ctaContent, ...p }, ref) => {
    return (
      <Col>
        <div style={{ position: 'relative' }}>
          <Input
            data-style={ctaContent ? { paddingRight: '120px' } : {}}
            error={error || ''}
            ref={ref as any}
            onMouseDown={(e) => e.stopPropagation()}
            {...p}
          />
          {ctaContent ? (
            <Button
              variant="text"
              color="primary"
              className={ctaButton}
              onClick={(e) => (onClick ? onClick(e as any) : null)}
            >
              {ctaContent}
            </Button>
          ) : rightIcon ? (
            <FontAwesomeIcon
              style={{ top: '10px' }}
              className={ctaButton}
              color={'#667085'}
              size={'sm'}
              icon={rightIcon}
              onClick={(e) => (onClick ? onClick(e as any) : null)}
            />
          ) : null}
        </div>
      </Col>
    );
  },
);
